import {useEffect} from 'react';
import {UserFlowStep} from '../../Facade/UserFlow/BaseUserFlow';
import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';
import {useUserFlowState} from '../../Components/Context/UserFlow/UserFlowContext';
import {useUiState} from '../../Components/Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Components/Context/UserInterface/UserInterfaceActionTypes';
import {useTaopix} from '../../Components/Context/TaopixContext';
import {ShareResponsePayload} from '../../Components/Share/ShareButton';
import {useErrorBoundary} from 'react-error-boundary';
import {UserFlowType} from '../../Facade/UserFlow/UserFlowFacade';

export const useShareObserver = (server: APIServer) => {
  const ui = useUiState();
  const userFlow = useUserFlowState();
  const taopix = useTaopix();
  const {showBoundary} = useErrorBoundary();

  const stepActive = userFlow.isStepActive(UserFlowType.Share, UserFlowStep.ShareInititialise);

  useEffect(() => {
    let controller;
    if (stepActive && !ui.state.busy) {
      controller = new AbortController();
      ui.dispatch(UserInterfaceActions.setIsBusy(true));
      taopix.core
        .get('server')
        .post<ShareResponsePayload>(
          '/api/project/share',
          {},
          {
            json: true,
            token: 'token',
          }
        )
        .then(({data}) => {
          PubSub.publish('SHARE_LINK', data.link);
          ui.dispatch(UserInterfaceActions.setIsBusy(false));
          userFlow.setNextStep();
        })
        .catch(error => {
          showBoundary(error.message);
        });
    }

    return () => {
      if (controller instanceof AbortController && !ui.state.busy) {
        controller.abort();
      }
    };
  }, [stepActive, ui.state.busy]);

  return;
};
